import { FunctionComponent } from 'react';
import { useMapRegionComuna } from '../../hooks/useMapRegionComuna';
import { useNodalCapacityMapData } from '../../hooks/useNodalCapacityMapData';
import MapLocationSelector from '../../components/nodalCapacityHeatMap/MapLocationSelector';
import NodalCapacityHeatMapView from '../../components/nodalCapacityHeatMap/NodalCapacityHeatMapView';
import '../../css/PublicMap.css';

/**
 * Vista privada del mapa de calor de capacidad nodal.
 * Idéntica a HeatMapPage pero muestra TODOS los estudios (Publica + Privada).
 */
const PrivateNodalHeatMapPage: FunctionComponent = () => {
  const {
    regiones,
    comunas,
    selectedRegion,
    selectedComuna,
    localMapCenter,
    alimentadorIds,
    loading: locationLoading,
    setSelectedRegion,
    setSelectedComuna
  } = useMapRegionComuna();

  const { data, loading: dataLoading } = useNodalCapacityMapData({
    endpoint: 'mapElements/nodal-capacity/internal',
    alimentadorIds
  });

  return (
    <div className='public-map-container vdr-map--private'>
      <MapLocationSelector
        regiones={regiones}
        comunas={comunas}
        selectedRegion={selectedRegion}
        selectedComuna={selectedComuna}
        loading={locationLoading}
        onRegionChange={setSelectedRegion}
        onComunaChange={setSelectedComuna}
      />
      <NodalCapacityHeatMapView
        data={data}
        loading={dataLoading || locationLoading}
        selectedComuna={selectedComuna}
        mapCenter={localMapCenter}
      />
    </div>
  );
};

export default PrivateNodalHeatMapPage;
